import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { LayoutGrid, LayoutList } from "lucide-react";

interface BuyerViewToggleProps {
  value: 'list' | 'tile';
  onChange: (value: 'list' | 'tile') => void;
}

export const BuyerViewToggle = ({ value, onChange }: BuyerViewToggleProps) => {
  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={(val) => {
        if (val) onChange(val as 'list' | 'tile');
      }}
      className="border rounded-lg"
    >
      <ToggleGroupItem value="list" aria-label="List view" className="px-3">
        <LayoutList className="h-4 w-4" />
        <span className="ml-2 hidden sm:inline">List</span>
      </ToggleGroupItem>
      <ToggleGroupItem value="tile" aria-label="Tile view" className="px-3">
        <LayoutGrid className="h-4 w-4" />
        <span className="ml-2 hidden sm:inline">Tiles</span>
      </ToggleGroupItem>
    </ToggleGroup>
  );
};
